import gql from 'graphql-tag'
import { EntityFields } from '..'

export const SerializationFragment = gql`
  fragment Serialization on files_serialization{
    ${EntityFields}
    config
    service
  }
`
